<script setup lang="ts">
import BottomBarComponent from '@/components/BottomBarComponent.vue';
import NextComponent from '@/components/NextComponent.vue';
import local from '@/stores/local';
import { onMounted, ref } from 'vue';
import { Checkbox, useRecaptchaProvider } from 'vue-recaptcha';
import { RouterLink } from 'vue-router';

useRecaptchaProvider()

const captchaResponse = ref()

function onSuccess(result: string) {
  local.setItem<string>('recaptcha', result)
}
</script>

<template>
  <v-container>
    <v-card>
      <v-card-text class="text-center">
        For at kunne bruge prisberegneren, skal vi være sikre på du ikke er en robot.
      </v-card-text>
      <v-card-text class="text-center">
        <Checkbox v-model="captchaResponse" @success="onSuccess" />
      </v-card-text>
    </v-card>
  </v-container>

  <BottomBarComponent>
    <NextComponent to="/agreement/vehicle" :disabled="!captchaResponse" />
  </BottomBarComponent>
</template>
